import heroHall from "../assets/hero-hall.jpg";
import templeInterior from "../assets/temple-interior.jpg";
import squareCompass from "../assets/square-compass.jpg";
import oldSingapore from "../assets/old-singapore.jpg";
import charity from "../assets/charity.jpg";
import centenaryJewel from "../assets/centenary-jewel.jpg";
import crestWhite from "../assets/crest-white.png";
import crestSeal from "../assets/crest-seal.png";
import crestTransparent from "../assets/crest-transparent.png";

export const images = {
  heroHall,
  templeInterior,
  squareCompass,
  oldSingapore,
  charity,
  centenaryJewel,
  crestWhite,
  crestSeal,
  crestTransparent,
};

export const lodge = {
  name: "The Zetland in the East Lodge No. 508 E.C.",
  shortName: "Zetland in the East",
  founded: "1845",
  address: "Freemasons' Hall, 23A Coleman Street, Singapore 179806",
  emailSecretary: "secretary@zetland508.org",
  emailMaster: "wmaster@zetland508.org",
  meeting: "Second Friday of every month",
  tyling: "6:30 PM",
  dress: "Formal Black Tie",
};

export const pillars = [
  {
    title: "Mentorship",
    body:
      "Connect with a diverse brotherhood of men across every walk of life. Find mentors, peers and a genuine support system beyond your usual circles.",
    icon: "Users",
  },
  {
    title: "Community Service",
    body:
      "Move beyond the screen and make a tangible difference. Our members serve Singapore through charity and community initiatives — including a children's charity founded in 2019.",
    icon: "HeartHandshake",
  },
  {
    title: "Personal Growth",
    body:
      "A journey of self-discovery. Develop confidence, sharpen public speaking, explore timeless moral questions and become the best version of yourself.",
    icon: "Sprout",
  },
];

export const timeline = [
  {
    year: "1845",
    title: "The Founding",
    body:
      "Lodge Zetland No. 748 was warranted on 26 February 1845 and consecrated on 8 December at the 'Masonic Room' on Armenian Street — the first mother lodge in Singapore and the seed of all Craft Freemasonry on the island. It was named for Thomas Dundas, 2nd Earl of Zetland, then Grand Master of the United Grand Lodge of England.",
    image: oldSingapore,
    caption: "1840s colonial Singapore, where the Lodge first met on Armenian Street.",
  },
  {
    year: "1846–1875",
    title: "Years of Movement",
    body:
      "From Armenian Street the Lodge moved to High Street (1846), to the Esplanade near present-day City Hall (1856), to Beach Road (1871), and to Hill Street (1875). Each home traced the growth of Singapore's young colonial core.",
    image: null,
    caption: null,
  },
  {
    year: "1879",
    title: "Freemasons' Hall, Coleman Street",
    body:
      "A land grant of 27 September 1878 was issued in favour of R.W. Bro. William Henry Macleod Read, District Grand Master and Past Master of the Lodge. The foundation stone was laid on 14 April 1879 with full Masonic ceremony, and the purpose-built Hall was consecrated on 27 November 1879 — the Lodge's home to this day.",
    image: heroHall,
    caption: "Freemasons' Hall — the Lodge's home since 1879.",
  },
  {
    year: "20th Century",
    title: "Continuity Through Change",
    body:
      "Through Singapore's transformation from colony to independent nation, the Lodge endured — preserving its ritual, records and fellowship across generations while the city rebuilt itself around Coleman Street.",
    image: centenaryJewel,
    caption: "The Zetland centenary jewel, marking 100 years of the Lodge.",
  },
  {
    year: "Today",
    title: "A Lodge for Modern Singapore",
    body:
      "Now Singapore's oldest Masonic lodge — older than the nation itself — Zetland 508 focuses on charity, mentorship and fellowship, welcoming a new generation of men of good character as it builds toward its bicentenary in 2045.",
    image: charity,
    caption: "The modern Lodge in service to the community.",
  },
];

export const faqs = [
  {
    q: "What is Freemasonry?",
    a: "Freemasonry is one of the world's oldest fraternal organisations — a society of men concerned with moral and spiritual values, personal integrity and community service. Often described as 'a peculiar system of morality, veiled in allegory and illustrated by symbols', it uses the tools and traditions of stonemasons as allegories for building better men.",
  },
  {
    q: "Is Freemasonry a religion?",
    a: "No. Freemasonry is not a religion and has no theology of its own. It requires a belief in a Supreme Being but is open to men of all faiths, and it encourages every member to be active in his own religious tradition. It is a complement to faith, never a substitute for it.",
  },
  {
    q: "Is Freemasonry a secret society?",
    a: "Freemasonry is a society with private customs, not a secret society. We are open about who we are, what we believe and where we meet. What we keep for the Lodge room are our traditional modes of recognition and the ceremonies of the degrees — the symbolic experience that gives initiation its meaning.",
  },
  {
    q: "Who can join?",
    a: "Any man of good character aged 21 or above who believes in a Supreme Being, regardless of background, faith or profession. We are professionals, entrepreneurs, creatives and thinkers united by shared values and a commitment to self-improvement and service.",
  },
  {
    q: "What happens at a meeting?",
    a: "The Lodge meets on the second Friday of each month. Meetings combine ceremony, the conduct of Lodge business and — importantly — fellowship afterward over a shared meal. The ceremonial work is reserved for members, but its purpose is simply moral instruction through allegory.",
  },
];

export const notableFigures = [
  { name: "Thomas Dundas, 2nd Earl of Zetland", note: "Grand Master of UGLE 1844–1870; the Lodge's namesake." },
  { name: "William Napier", note: "Senior lawyer; the Lodge's first initiated Brother, 15 December 1845." },
  { name: "William Henry Macleod Read", note: "District Grand Master and Past Master; the 1878 land grant was in his name." },
  { name: "Sir Stamford Raffles", note: "Founder of modern Singapore; a Freemason initiated in Java (Dutch constitution) in 1812." },
];
